<template>
  <div>
    <b-card>
      <h3 class="text-red">
        {{ $t("witholding_taxes") | startcase }}
      </h3>
    </b-card>
    <t-table
        :id="`rights-holder-witholding-taxes`"
        :columns="witholdingTaxesTableColumns"
        :local-data="withholdingTaxesMapped"
        :options="witholdingTaxesTableOptions"
    >
      <template v-slot:rate="{row}">
        {{ row.rate | formatNumber }}%
      </template>
      <template v-slot:tax_type="{row}">
        {{ getTaxType(row.country) }}
      </template>
    </t-table>
  </div>

</template>

<script>
import { capitalize, startCase } from "lodash"

export default {
  name: "RightsHolderWithholdingTaxes",
  props: {
    rightsholderId: String,
  },
  methods: {
    async getWithholdingTaxes (rightsholderId) {
      const res = await this.$api.rightsholders.rightsholderWithholdingTaxes(rightsholderId)
      return res.data
    },
    getTaxType (taxCountry) {
      if (!taxCountry) {
        return "-"
      }
      return taxCountry === "CA" ? capitalize(this.$t("domestic")) : capitalize(this.$t("international"))
    }
  },
  watch: {
    rightsholderId: {
      handler (value) {
        if (value) {
          this.getWithholdingTaxes(value).then(data => {
            this.withholdingTaxes = data
          })
        }
      },
      immediate: true
    },
  },
  computed: {
    withholdingTaxesMapped () {
      const data = []
      this.withholdingTaxes.map(
        tax => {
          tax.taxCountry.map(
            country => {
              data.push({ country, rate: tax.withholdRate })
            }
          )
        }
      )
      return data
    }
  },
  data () {
    return {
      withholdingTaxes: [],
      witholdingTaxesTableOptions: {
        sortable: [],
        headings: {
          country: startCase(this.$t("revenue_source_country")),
          rate: startCase(this.$t("rate")),
          tax_type: startCase(this.$t("type")),
        },
      },
      witholdingTaxesTableColumns: [
        "tax_type",
        "country",
        "rate",
      ]
    }
  }
}
</script>
